export const USER_FEEDBACK = {
  POSITIVE: "thumbs-up",
  NEGATIVE: "thumbs-down",
};

export const logUserFeedbackResponseMock =
  "Mock, User Feedback has been stored successfully";
